import { useQuery } from '@tanstack/react-query';
import { Foreground } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

// Senior overlays offered in the builder carousel. When a `season` is given
// (the student's senior season, e.g. "seniors2027"), only overlays tagged for
// that class year are returned -- so the class of 2026 and the class of 2027 are
// offered different "Class of YYYY" sets, and old-year orders keep their own.
// Without a season (loading / non-senior) it returns all senior overlays, the
// prior behavior.
export default function useForegrounds(season = null) {
  return useQuery([QUERY_KEYS.foregrounds, 'senior', season || 'all'], () => {
    let scope = Foreground.where({ senior: true });
    // Exact class-year match (seniors2026 != seniors2027); see the class_year
    // filter in Api::ForegroundResource. Falsy/non-string season => unscoped.
    if (season && typeof season === 'string') scope = scope.where({ classYear: season });

    return scope.all().then((res) => res.data);
  }, { placeholderData: [] });
}
